import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IChangePassword {
  old_password: string;
  new_password: string;
  confirm_password: string;
}

const changePassword = (postFormData: IChangePassword) => {
  return http().post(endpoints.profile.changePassword, postFormData);
};

export function useChangePassword() {
  return useMutation({ mutationFn: changePassword });
}
